import { CogStopOutlineIcon } from './CogStopOutlineIcon';

/**
 * author: Michael Irigoyen
 * id F937057A-B769-4F5E-A079-7D9BF4679807
 * name cog-stop-outline
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-stop-outline.svg
 * tags
 * - Settings 
 */
export const SettingsStopOutlineIcon = CogStopOutlineIcon;
export default SettingsStopOutlineIcon